import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const MobileAppChat = lazy(() => import("./MobileAppChat"));

const membershipRoutes: RouteObject[] = [
  {
    path: "/chat",
    element: (
      <Suspense fallback={<Loading />}>
        <MobileAppChat />
      </Suspense>
    ),
  },
];

export default membershipRoutes;
